import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const login = () => import(/* webpackChunkName: "login" */ '@/components/login/login.vue');
const history = () => import(/* webpackChunkName: "history" */ '@/components/login/history.vue');
const index = () => import(/* webpackChunkName: "home" */ '@/components/index.vue');
const bucket = () => import(/* webpackChunkName: "bucket" */ '@/components/desktop/bucket.vue');
const file = () => import(/* webpackChunkName: "file" */ '@/components/desktop/file.vue');
const editor = () => import(/* webpackChunkName: "file" */ '@/components/desktop/editor/index.vue');

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/history',
      name: 'history',
      component: history,
    },
    {
      path: '/web',
      component: index,
      name: 'web',
      children: [
        {
          path: 'bucket',
          name: 'bucket',
          component: bucket,
        },
        {
          path: 'file',
          name: 'file',
          component: file,
          props: route => ({ query: route.query }),
        },
      ],
    },
    {
      path: '/editor',
      component: editor,
      name: 'editor',
      props: route => ({ query: route.query }),
    },
  ],
});

// 路由跳转处理
router.beforeEach((to, from, next) => {
  // if (to.name === 'editor') {
  //   const open = storage.get('openEditorMode');
  //   if (!open) {
  //     storage.add('openEditorMode', 'open');
  //   }
  // }
  // 错误路由拦截
  if (to.name === null) {
    next('/login');
  } else {
    next();
  }
});

export default router;
